import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ChopAlterskategorie, ChopKatalog } from '@entity/chop';
import { ChopService } from '@service/chop.service';

export interface ChopKatalogDetailData {
  katalog: ChopKatalog;
  alterskategorien: ChopAlterskategorie[];
}

export const ChopKatalogDetailResolve: ResolveFn<ChopKatalogDetailData> = (route) => {
  const chopService = inject(ChopService);
  const katalogId = +route.params.katalogId;
  return forkJoin({
    katalog: chopService.getKatalog(katalogId),
    alterskategorien: chopService.getAlterskategorien(katalogId),
  });
};
